module.exports = __webpack_public_path__ + "static/media/Terminal_ID_Update_Sample_Sheet.bfc04e8c.xlsx";